import flattenDeep from 'lodash/flattenDeep';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import range from 'lodash/range';
import uniq from 'lodash/uniq';

import { User, userFactory } from '@/types/user';

export const getInitialUser = (value: User[], limit: number) => {
  const newValue = value.slice(0, limit);
  return [
    ...newValue,
    ...range(limit < value.length ? 0 : limit - value.length).map(() =>
      userFactory(),
    ),
  ];
};

/**
 * エラーメッセージをサマる
 */
export const flattenUniqueValues = (obj: unknown): any[] => {
  const pickValues = (ob: unknown): any[] => {
    if (isArray(ob)) {
      return ob.map((o) => pickValues(o));
    }
    if (!isObject(ob)) {
      return pickValues({ ob });
    }

    return Object.keys(ob).map((key) => (ob as Record<string, any>)[key]);
  };

  return uniq(flattenDeep(pickValues(obj)).filter((o) => !!o));
};

export const filterEmptyUser = (users: User[]) =>
  users.filter((user) =>
    [
      user.firstName,
      user.lastName,
      user.kanaFirstName,
      user.kanaLastName,
      user.email,
    ].some((v) => v !== ''),
  );

export const getDuplicationEmailIndexes = (users: User[]) => {
  const values = users.map((user) => user['email']);
  const duplicatedIndexes = values
    .map((v, i) =>
      v && values.indexOf(v) !== values.lastIndexOf(v) ? i : null,
    )
    .filter((v) => v !== null);

  return duplicatedIndexes;
};
